.logo {
	@apply
	yst-w-[200px]
	yst-max-w-full
	yst-h-auto;
}
